<template>
  <div class="card-body pt-0">
    <div class="bg-white pt-3 d-flex">
      <div class="w-100" :class="editor != 'cat-' + category.id && 'd-flex align-items-center gap-1'">
        <div
          v-if="editor == 'cat-' + category.id"
          class="cards row g-3 d-flex justify-content-start align-items-stretch"
        >
          <template v-for="(page, index) in fillerpages" :key="index">
            <label class="col-auto col-xxl-2 cursor-pointer">
              <input
                :value="page.name"
                :checked="page.name == category.attributes.data?.name"
                type="radio"
                :name="editor + '-filler'"
                @change="updateFiller"
              />
              <base-card-compact
                :image="page.img"
                :title="page.name"
                customheight="8rem"
                customwidth="calc(8rem * 0.707)"
              >
              </base-card-compact>
            </label>
          </template>
        </div>
        <template v-else>
          <h5 class="text-secondary fw-bold mb-0 handle" :class="{ disabled: multicheck }">
            <svg
              height="1em"
              viewBox="0 0 1792 1792"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="cursor-move"
              style="margin-top: -0.25rem"
            >
              <path
                d="M1408 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45zm0-384q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"
              ></path>
            </svg>
            <span class="ms-2" style="color: #a05a60">
              <i class="bi bi-file-earmark-image"></i>
            </span>
            Designseite
          </h5>
          {{ category.attributes.data?.name ? '(' + category.attributes.data.name + ')' : '' }}
        </template>
      </div>
      <div>
        <div
          v-if="multicheck"
          class="checkbox ms-3"
          :class="{
            'mb-3': category.relationships.menuItems.data.length > 0,
          }"
        >
          <label class="d-flex gap-2 align-items-center mb-1">
            <input v-model="mltchckd" :value="'cat-' + category.id" type="checkbox" class="form-check-input" />
            <div class="check fs-4"></div>
          </label>
        </div>
        <button
          v-else-if="editor != 'cat-' + category.id"
          type="button"
          class="btn border text-muted hover:text-secondary"
          @click="changeEditor('cat-' + category.id)"
        >
          <i class="bi bi-pencil-fill"></i>
        </button>
        <div v-else class="btn-group-vertical ms-3" role="group">
          <button
            type="button"
            class="btn border text-muted hover:text-secondary"
            @click="changeEditor('cat-' + category.id)"
          >
            <base-icon-save></base-icon-save>
          </button>
          <button type="button" class="btn border text-muted hover:text-primary" @click="deleteCategory(category.id)">
            <i class="bi bi-trash-fill"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';

import { useVModel } from '@vueuse/core';

import isNil from 'lodash/isNil';

export default {
  props: {
    category: {
      type: Object,
      default: null,
    },
    editor: {
      type: String,
      default: '',
    },
    changeEditor: {
      type: Function,
      default: null,
    },
    deleteCategory: {
      type: Function,
      default: null,
    },
    multicheck: {
      type: Boolean,
      default: false,
    },
    multichecked: {
      type: Array,
      default: null,
    },
  },
  emits: ['update:data', 'update:multichecked'],
  setup(props, { emit }) {
    const mltchckd = useVModel(props, 'multichecked', emit);
    const fillerpages = [
      {
        name: 'Coke-Flaschen',
        img: '/images/fillers/bottles.jpg',
      },
      {
        name: 'Coke-Flasche mit Glas',
        img: '/images/fillers/coke-glass.jpg',
      },
      // {
      //   name: 'Coke mit Hotdogs',
      //   img: '/images/fillers/hotdog.jpg',
      // },
      // {
      //   name: 'Coke mit Freunden',
      //   img: '/images/fillers/people.jpg',
      // },
      // {
      //   name: 'Coke mit Spaghetti',
      //   img: '/images/fillers/spaghetti.jpg',
      // },
      {
        name: 'Römerquelle mit Kaffee',
        img: '/images/fillers/rq-kaffee.jpg',
      },
      {
        name: 'Römerquelle mit Wein',
        img: '/images/fillers/rq-wein.jpg',
      },
      // {
      //   name: 'Vergnano mit Römerquelle',
      //   img: '/images/fillers/vergnano-rq.jpg',
      // },
      // {
      //   name: 'Costa mit Römerquelle',
      //   img: '/images/fillers/costa-rq.jpg',
      // },
    ];

    const updateFiller = (event) => {
      emit('update:data', {
        target: {
          id: 'cat-' + props.category.id + '-data',
          value: { name: event.target.value },
        },
      });
    };

    onMounted(() => {
      if (isNil(props.category.attributes?.data?.name)) {
        updateFiller({ target: { value: fillerpages[0].name } });
      }
    });

    return {
      updateFiller,
      fillerpages,
      mltchckd,
    };
  },
};
</script>

<style lang="scss" scoped></style>
